import { StrictMode, useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import { createRouter, RouterProvider } from '@tanstack/react-router'

import { routeTree } from './routeTree.gen'
import { useAuthStore } from './stores/auth-store'
import { httpClient } from './services/http-client'
import { ThemeContextProvider } from './theme'

// The bundle loaded: clear index.html's one-shot "bundle failed, reload" guard
// and the cache-busting query it may have added (issue #35).
try {
  sessionStorage.removeItem('fw-asset-reload')
  const u = new URL(window.location.href)
  if (u.searchParams.has('_v')) {
    u.searchParams.delete('_v')
    window.history.replaceState(window.history.state, '', u.pathname + u.search + u.hash)
  }
} catch {
  // storage unavailable: nothing to clear
}

// Attach the persisted session BEFORE the first render. Child effects run
// before App's, so a page opened by direct link (e.g. /connections) used to
// fire its first request with no Authorization header and lean on a 401 +
// refresh round trip to recover (issue #35).
{
  const persisted = useAuthStore.getState().token
  if (persisted) httpClient.setAuthToken(persisted)
}

// Create the router instance
const router = createRouter({ routeTree })

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const App = () => {
  const { token } = useAuthStore()

  useEffect(() => {
    // Set auth token in HTTP client if available
    if (token) {
      httpClient.setAuthToken(token)
    }
  }, [token])

  return <RouterProvider router={router} />
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeContextProvider>
      <App />
    </ThemeContextProvider>
  </StrictMode>,
)
